/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
export default function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` is required to make ") + "`".concat(componentNameSafe, "` accessible for users of assistive ") + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(void 0, [props, propName, componentName, location, propFullName].concat(args));
  };
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/isRequiredForA11y.js